// App.js
import "./App.css";
import Header from "./Header";
// import Home from "./Home";
import Footer from "./Footer";
import Maincontent from "./Maincontent";
import { Outlet } from "react-router-dom";



function App() {
  return (
    <div className="app">
      {/* <Header/> */}
      <Maincontent />
            {/* <Outlet /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default App;